import React from 'react';
import './staff-profile.scss';
import { ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CommonApi from '../../../../apis/common'
import Dropdown from '../../../common/dropdown-v2/dropdown';
import SessionCache from '../../../routes/session-cache';
import SchoolApi from '../../../../apis/school'
import CommonUtils from '../../../../utility/common-utilities';

class ChangePassword extends React.Component {
    state = {
        loading: "",
        isSubmit: false,
    }

    constructor() {
        super()
        this.getCountryCodes();
        this.getStaffInfo()
    }


    getStaffInfo() {
        let user = SessionCache.getUser()
        this.state.name = user.name
        this.state.mobileNumber = user.mobileNumber
        this.state.selectedCountryCode = user.countryCode
        this.state.landline = user.landline
    }

    onChangeHandler = (event, key) => {
        if (key == "mobileNumber") {

            if (!event.target.value) {
                this.setState({ mobileNumber: event.target.value, })
                return
            }

            if (!CommonUtils.isAllowMobileNumber(event.target.value)) {
                let stateValue = this.state.mobileNumber
                this.setState({ mobileNumber: "" }, () => {
                    this.setState({ mobileNumber: stateValue })
                })
                return
            }
        }

        this.setState({ [key]: event.target.value, isInvalidMobile: false, errorMessage: "" })
    }

    getCountryCodes(payload) {

        CommonApi.getCountryCodeList(payload).then(response => {
            let data = response.response
            if (data.length) {
                this.setState({ countryList: data })
                let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                this.setState({ countryCodeDropdown: countryCodeDropdown })

            }
        }).catch(err => {
        })

    }

    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = [];
        let countryCodeHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]

            if (!countryCodeHash[item.dialCode]) {
                countryCodeHash[item.dialCode] = item
                countryCodeDropdown.push({ title: `${item.name} (${item.dialCode})`, value: item.dialCode })
            }
        }
        this.setState({ hashedCountryCode: countryCodeHash })
        return countryCodeDropdown
    }


    onSelectCountryCode(option) {
        this.setState({ selectedCountryCode: option?.value })
    }

    onConfirm = () => {

        let payload = {
            firstName: this.state.name || "",
            countryCode: this.state.selectedCountryCode || "",
            mobileNumber: this.state.mobileNumber || "",
            landline: this.state.landline
        }

        let validate = this.validatePayload(payload)
        if (!validate) return

        if (this.isSubmit) return
        this.isSubmit = true
        SchoolApi.confirmStaffProfile(payload).then(response => {
            this.props.onSave && this.props.onSave()
        }).catch(err => {

            this.isSubmit = false
        })

    }

    validatePayload(payload) {
        if (!payload.firstName.trim()) {
            this.setState({ errorMessage: "Please enter name" })
            return false
        }
        if (!payload.countryCode) {
            this.setState({ errorMessage: "Please select country  code" })
            return false
        }
        if (!payload.mobileNumber.trim()) {
            this.setState({ errorMessage: "Please enter mobile number" })
            return false
        }

        let countryCodeDetail = this.state.hashedCountryCode[this.state.selectedCountryCode]
        let validateCountryCode = CommonUtils.validateMobileNumber(this.state.mobileNumber, countryCodeDetail)
        if (!validateCountryCode) {
            this.setState({ isInvalidMobile: true, errorMessage: "Invalid Mobile Number" })
            return false
        } else {
            this.setState({ isInvalidMobile: false })
        }


        this.setState({ errorMessage: "" })
        return true

    }
    render() {
        return (
            <div className="staff-profile">
                <div className="row">
                    <div className="col">
                        <div className="text-header">
                            <strong>{this.props.headerTitle}</strong>
                        </div>

                        <div className="sign-up center-box pt-2">
                            <div className='cw-card'>
                                <div className='cw-card-body'>

                                    <div className='row'>
                                        <div className='col'>
                                            <label className='cw-input-label'>Name<span className='star'></span></label>
                                            <input className={`cw-input ${!this.state.name ? "invalid" : ""}`}
                                                placeholder='Enter Your Name'
                                                onChange={(e) => this.onChangeHandler(e, 'name')}
                                                value={this.state.name}
                                            />
                                        </div>
                                    </div>


                                    <div className='bw-spaces-input'>
                                        <div className='cw-input-label'>PHONE NUMBER</div>
                                        <div className='row'>
                                            <div className='col-4 pr-0'>
                                                {
                                                    this.state.countryCodeDropdown?.length ?
                                                        <Dropdown
                                                            key="countryCode"
                                                            placeholder='Search country'
                                                            options={this.state.countryCodeDropdown}
                                                            onSelect={(option) => this.onSelectCountryCode(option)}
                                                            text="title"
                                                            style={{ background: "#F6F7F5" }}
                                                            value={this.state.selectedCountryCode}
                                                            invalid={this.state.isSubmit && !this.state.selectedCountryCode}
                                                        /> : ""
                                                }
                                            </div>
                                            <div className='col'>
                                                <input className={`cw-input ${!this.state.mobileNumber || this.state.isInvalidMobile ? "invalid" : ""}`} placeholder='Enter Mobile Number'
                                                    value={this.state.mobileNumber}
                                                    onChange={(e) => this.onChangeHandler(e, 'mobileNumber')} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row bw-spaces-input'>
                                        <div className='col'>
                                            <label className='cw-input-label'>LANDLINE</label>
                                            <label className='float-right optional'>OPTIONAL</label>
                                            <input className={`cw-input `}
                                                placeholder='Enter Your Landline Number'
                                                onChange={(e) => this.onChangeHandler(e, 'landline')}
                                                value={this.state.landline}
                                            />
                                        </div>
                                    </div>

                                </div>
                                {
                                    this.state.errorMessage ?

                                        <div className='pb-4 text-center ' onClick={this.onConfirm}>
                                            <span className='text-danger'><b>{this.state.errorMessage} </b></span>
                                        </div>
                                        : ""
                                }
                                <div className='cw-card-footer' onClick={this.onConfirm}>
                                    <span className='footer-text'>Continue </span>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='col py-4'>
                        <img src={getImageSource(ImageConstants.FORGOT_PASSWORD)} className='profile-vector-img' />
                    </div>
                </div>
            </div >
        );
    }
}

export default ChangePassword;